import { getData } from '../../constants/api_index';

class bannerService {
  getBanner() {
    return getData('banner');
  }
}

export default new bannerService();
